import './App.css';
import About from './components/About';
import FAQ from './components/Faq';
import Header from './components/Header';
import Product from './components/Product';
import Review from './components/Review';


function Karungali() {
  return (
    <div>
      <Header />
      <About />
      <Product />
      <FAQ />
      <Review />
    </div>
  );
}


export default Karungali;